import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '@/components/Logo';
import { Mail, MapPin, Phone } from 'lucide-react';

export default function Footer({ lang = 'ar' }) {
  const { t } = useTranslation();
  const isAr = lang === 'ar';
  const privacyPath = `/${lang}/${isAr ? 'privacidad' : 'privacy'}`;
  const cookiesPath = `/${lang}/cookies`;
  const termsPath = `/${lang}/${isAr ? 'terminos' : 'terms'}`;
  const home = `/${lang}`;
  const year = new Date().getFullYear();

  return (
    <footer className="zt-footer">
      <div className="container-zt section-pad" style={{ paddingTop: 72, paddingBottom: 48 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 40 }} className="footer-grid">
          <div style={{ gridColumn: 'span 2' }} className="footer-brand">
            <Logo tone="paper" />
            <p style={{ marginTop: 16, opacity: 0.8, maxWidth: 380, lineHeight: 1.6 }}>{t('footer.tagline')}</p>
            <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 10, fontSize: 14, opacity: 0.85 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}><MapPin size={16} style={{ marginTop: 2, flexShrink: 0 }} /><span>{t('contact.address')}</span></div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><Phone size={16} /><a href={`tel:${t('contact.phone').replace(/\s+/g,'')}`}>{t('contact.phone')}</a></div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><Mail size={16} /><a href="mailto:hola@zantravina.com">hola@zantravina.com</a></div>
            </div>
          </div>

          <div>
            <div style={{ fontSize: 12, letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.6, marginBottom: 16 }}>{t('footer.linksTitle')}</div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10, fontSize: 14 }}>
              <li><a href={`${home}#about`}>{t('nav.about')}</a></li>
              <li><a href={`${home}#how`}>{t('nav.how')}</a></li>
              <li><a href={`${home}#projects`}>{t('nav.projects')}</a></li>
              <li><a href={`${home}#contact`}>{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div>
            <div style={{ fontSize: 12, letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.6, marginBottom: 16 }}>{t('footer.legalTitle')}</div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10, fontSize: 14 }}>
              <li><Link to={privacyPath} data-testid="footer-privacy">{t('footer.privacy')}</Link></li>
              <li><Link to={cookiesPath} data-testid="footer-cookies">{t('footer.cookies')}</Link></li>
              <li><Link to={termsPath} data-testid="footer-terms">{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div style={{ marginTop: 56, paddingTop: 24, borderTop: '1px solid rgba(244,239,230,0.14)', display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 24, fontSize: 13, opacity: 0.7 }} className="footer-legal">
          <div style={{ lineHeight: 1.7 }}>
            <div><strong style={{ opacity: 1, color: 'var(--paper)' }}>{t('footer.companyName')}</strong></div>
            <div>{t('footer.cuit')}</div>
            <div>{t('footer.registration')}</div>
            <div>{t('footer.license')}</div>
            <div>{t('footer.jurisdiction')}</div>
            <div>{t('footer.incorporated')}</div>
          </div>
          <div style={{ lineHeight: 1.7 }}>{t('footer.disclaimer')}</div>
        </div>

        <div style={{ marginTop: 32, fontSize: 12, opacity: 0.55 }}>
          © {year} {t('footer.companyName')}. {t('footer.rights')}
        </div>
      </div>
      <style>{`
        @media (max-width: 900px){
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
          .footer-brand { grid-column: span 2 !important; }
          .footer-legal { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 560px){
          .footer-grid { grid-template-columns: 1fr !important; }
          .footer-brand { grid-column: span 1 !important; }
        }
      `}</style>
    </footer>
  );
}
